import axios from "utils/axiosInstance";
import { ReverifyDomainRequest } from "utils/data/shopext";

export const reverifyDomainAPI = (request: ReverifyDomainRequest) => {
  return axios.post("/internal-tool/v1/reverify-domain", request, {
    withCredentials: true,
  });
};
